import { FlatRoomsContainer } from '../../containers/advancedFilters/FlatRoomsContainer';
import { IFilter } from '../../types/advancedFilters';

export const flatRooms: IFilter = {
  component: FlatRoomsContainer,
};
